import { UvRoute } from '@/lib/router';
import modules from '@/pages/admin/assets/modules/routes';
import { CreateElement } from 'vue';

const route: UvRoute = {
  path: 'assets',
  component: {
    render: (h: CreateElement) => h('router-view'),
  },
  children: [modules],
};

export default route;
